module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-Green.82c47998.jpg";